import React from 'react'

const EtAdminSiteHealth = () => {
  return (
    <div>EtAdminSiteHealth</div>
  )
}

export default EtAdminSiteHealth